export default __webpack_public_path__ + "static/media/chart-no-data.fee77dfa.svg";